import { motion } from "framer-motion";

export const PageHeader = ({ eyebrow, title, subtitle }) => {
  return (
    <section className="pt-32 pb-12 md:pt-40 md:pb-16">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        {eyebrow && (
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-brand-red mb-4">
            {eyebrow}
          </div>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="font-heading font-black tracking-tight leading-[1.02] text-4xl sm:text-5xl lg:text-6xl text-brand-black max-w-none [text-wrap:balance] [hyphens:none] [overflow-wrap:normal]"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="mt-5 text-base md:text-lg text-brand-ink max-w-none leading-relaxed [text-wrap:pretty]"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
};
